export const LOCALES = ['en', 'bg'] as const;
export type Locale = (typeof LOCALES)[number];

/** BCP 47 tags used for Intl formatting. English uses en-GB for European date/number conventions. */
export const INTL_LOCALE: Record<Locale, string> = {
  en: 'en-GB',
  bg: 'bg-BG',
};

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

export function detectLocale(languages: readonly string[]): Locale {
  for (const lang of languages) {
    const base = lang.toLowerCase().split('-')[0];
    if (isLocale(base)) return base;
  }
  return 'en';
}

/**
 * The language a link asks for (`?lang=bg`), or null. It applies to that visit only and is never
 * saved as the visitor's preference.
 */
export function linkLocale(search: string): Locale | null {
  const lang = new URLSearchParams(search).get('lang');
  return isLocale(lang) ? lang : null;
}
